




















import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { db } from "@/scripts/firebase";
import { collectionName } from "../../services/collection-name";
import {
  UserJinroInfoDocument,
  UserJinroInfoJinroRoomDocument,
} from "../../services/datatypes";

@Component({
  components: {},
})
export default class AttendedJinroRoom extends Vue {
  detacher?: firebase.Unsubscribe;
  userJinroInfo: UserJinroInfoDocument | null = null;
  columns = [
    {
      field: "jinroRoom.title",
      label: "人狼部屋名",
      sortable: true,
      numeric: true,
    },
    {
      field: "playerId",
      label: "プレイ画面",
      sortable: true,
      numeric: true,
      visible: true,
    },
  ];

  async created() {
    this.detacher = this.refUserJinroInfo.onSnapshot((snapshot) => {
      this.userJinroInfo = snapshot.data() as UserJinroInfoDocument;
    });
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  get joinedJinroRooms(): Array<UserJinroInfoJinroRoomDocument> {
    if (!this.userJinroInfo || !this.userJinroInfo.joinedJinroRooms) {
      return [];
    }
    const row = this.userJinroInfo.joinedJinroRooms;
    // 参加したタイミングが新しい順に変更
    row.reverse();
    return row;
  }

  get uid(): string {
    if (this.$store.state.firebaseUser) {
      return this.$store.state.firebaseUser.uid;
    }

    return "";
  }

  get refUserJinroInfo(): firebase.firestore.DocumentReference {
    return db.collection(collectionName.userjinroinfo).doc(this.uid);
  }
}
